import { useLocation } from "react-router-dom";

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

export function useQueryParamsLowercase() {
  return new URLSearchParams(useLocation().search.toLowerCase());
}

export default useQueryParams;
